export function applyPeriodoFilterToParams(
  params: URLSearchParams,
  periodo: { id: number; descripcion?: string; estado?: string },
): boolean {
  const descripcion = periodo.descripcion?.trim();
  if (periodo.id == null || !descripcion) return false;

  params.set('page', '1');
  params.set('periodoId', String(periodo.id));
  params.set('periodoLabel', descripcion);
  if (String(periodo.estado ?? '').toUpperCase() === 'ARCHIVADO') {
    params.set('incluirArchivado', 'S');
  } else {
    params.delete('incluirArchivado');
  }
  return true;
}
